import { render, staticRenderFns } from "./TemplateEditForm.vue?vue&type=template&id=77200c1c&scoped=true"
import script from "./TemplateEditForm.vue?vue&type=script&lang=ts"
export * from "./TemplateEditForm.vue?vue&type=script&lang=ts"
import style0 from "./TemplateEditForm.vue?vue&type=style&index=0&id=77200c1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77200c1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VContainer,VForm,VRow})
